import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';

import { Button, Row, Col, Form, setParamsFilter, ProTableOt, useProTableOt, DemoProTableOt, message, Modal } from "../../../../../../templates/my-app/src/components/ui/ot"
import { useSOP } from "../controller/sop_controller";
import { useTranslation } from 'react-i18next';
import SOPModal, { SOPForm } from './sop_modal';



const SOPTable = ({
    edit = true,
    api = `/pmis/ai_flow_automation/sop/flow`,
    onCheckTesk = () => { },
    modalFlag = 0,
    keyPrefix = "pmis.sop",
    onSelectChange = () => { },
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    customColumns = [],
    customFormItems = () => { },
    propsShowKeys = [
        { key: "key", name: "key", hidden: false, require: false },
        { key: "sop_name", name: "sop_name", hidden: false, require: false },
        { key: "person_in_charge", name: "person_in_charge", hidden: false, require: false },
        { key: "average_worktime", name: "average_worktime", hidden: false, require: false },
        { key: "remark", name: "remark", hidden: false, require: false },
        { key: "操作", name: "操作", hidden: false, require: false },
    ],
    PropsPatchForm,
    propsFormReloadCount = 0,
    formMode,
    ...props
}) => {
    const navigate = useNavigate();
    const { t } = useTranslation('translation', { keyPrefix })
    const PatchForm = PropsPatchForm ?? <SOPForm
        // propsForm={form}
        propsShowKeys={propsShowKeys}
        keyPrefix={keyPrefix}
        customFormItems={customFormItems}
        formReloadCount={propsFormReloadCount}
        formMode={formMode}

    />
    const defaultColumns = [
        {
            title: t('index'),
            sorter: false,
            dataIndex: 'key',
            key: 'key',
            width: "10rem",
        },
        {
            title: t('sop_name'),
            sorter: false,
            dataIndex: 'sop_name',
            key: 'sop_name',
            width: "10rem",
        },
        {
            title: t('person_in_charge'),
            sorter: false,
            dataIndex: 'person_in_charge',
            key: 'person_in_charge',
            width: "10rem",
        },
        {
            title: t('average_worktime'),
            sorter: false,
            dataIndex: 'average_worktime',
            key: 'average_worktime',
            width: "10rem",
        },
        {
            title: t('remark'),
            sorter: false,
            dataIndex: 'remark',
            key: 'remark',
            width: "10rem",
        },
        {
            title: t('action'),
            dataIndex: '操作',
            sorter: false,
            key: '操作',
            fixed: "right",
            disabled: true,
            width: "4rem",
            render: (_, record) => {
                return (
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Button
                                variant={"sop_setting"}
                                style={{
                                    color: '#3FA68C'
                                }}
                                onClick={() => {
                                    navigate('../sop_display', { state: record });
                                }}
                            >
                                {t('sop_setting')}
                            </Button>
                        </Col>
                    </Row>
                )
            }
        }
    ]

    const columns = [
        ...defaultColumns.filter(column => propsShowKeys.some(keyObj => keyObj.key === column.key && keyObj.hidden !== true && !keyObj.formOnly)),
        ...customColumns,
    ]
    const actionRef = useRef(null)
    const [checkTask, setCheckTask] = useState([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectedRowsInfo)
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectedRowsKeys)
    const [extra_columns, set_extra_columns] = useState([]);
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.sop_id)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.sop_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                select_temp.push(record.sop_id)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.sop_id)
                selectRow = selectRow.filter(row => row.sop_id !== record.sop_id)
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };

    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)
    const [form] = Form.useForm();
    const [axiosMode, setAxiosMode] = useState("get")


    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])

            }
            setModalLoading(false)
            setModalOpen(false)
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
                // actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                // actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                // actionRef.current.reloadAndRest();
            }
            // setModalLoading(false)
            // setModalOpen(false)
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        // setModalLoading(true)
    }

    const {
        getSOPData,
        postSOPData,
        patchSOPData,
        deleteSOPData,
    } = useSOP({
        onFinish,
        onBefore,
    });
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
        transferColumnAntdToShadcn,
        transferSortAntdToShadcn
    } = useProTableOt({
        columns
    })
    useEffect(() => {
        onCheckTesk(checkTask)
    }, [checkTask])

    useEffect(() => {
        checkAll()
    }, [])

    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])

    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <ProTableOt
                    actionRef={actionRef}
                    columns={columns}
                    check={check}
                    setCheck={setCheck}
                    headerTitle={<>SOP列表</>}
                    rowKey={'sop_id'}
                    request={async (params = {}, sort, filter) => {
                        let newParams = {
                        };
                        let order = setOrders(sort)
                        newParams = {
                            ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword,
                            custom_filter_key: custom_filter_key
                        }
                        newParams = {
                            ...newParams,
                        }
                        newParams = setParamsFilter({
                            ...newParams,
                        });
                        return getSOPData({
                            ...newParams
                        })
                    }}
                    rowSelection={{
                        type: 'checkbox',
                        selectedRowKeys: selectedRowKeys,
                        ...rowSelection,
                    }}
                    extra_columns={extra_columns}
                    set_extra_columns={set_extra_columns}
                    manage_columns={false}
                    scroll={{
                        x: "100vw"
                    }}
                    toolBarRender={(tools) => [
                    ]}
                    propsPost
                    propsPatch
                    propsDelete
                    PropsPatchForm={PatchForm}
                    propsUseData={() => {
                        return {
                            getData: getSOPData,
                            postData: postSOPData,
                            patchData: patchSOPData,
                            deleteData: deleteSOPData,
                        }
                    }}
                    modalOpen={modalOpen}
                    setModalOpen={setModalOpen}
                    formMode
                />
            </Col>
        </Row >
    )
}
const SOP = ({
    propsForm,
    onFormFinish = () => { },
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    ...props
}) => {

    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <SOPTable
                    defaultSelectedRowsInfo={defaultSelectedRowsInfo}
                    defaultSelectedRowsKeys={defaultSelectedRowsKeys}
                />
            </Col>
        </Row>
    )
}
export { SOPTable }
export default SOP;